/* CUSTOM 2026-07-30 — Preis im "In den Warenkorb"-Button bei Mengenwechsel aktualisieren.

   Ausgangslage: <product-buy-price> in assets/theme.js hoert nur auf 'bundle:change'
   (Bundle-Zusatzartikel). Aendert der Kunde die MENGE, bleibt der Preis im Button stehen —
   er zeigt dauerhaft den Einzelpreis.

   Warum als eigene Datei statt Aenderung in theme.js: theme.js wird bei einem Theme-Update
   ueberschrieben, dieser Patch bleibt erhalten. Er erweitert die vorhandene Komponente, statt
   sie zu ersetzen — Bundle-Logik und Waehrungsformatierung des Themes bleiben unangetastet.
*/
(() => {
  if (window.__customBuyPriceQuantityPatched) return;
  window.__customBuyPriceQuantityPatched = true;

  const init = () => {
    if (!window.customElements || !customElements.get('product-buy-price')) return;

    const Basis = customElements.get('product-buy-price');

    /* Menge aus dem zugehoerigen Formular lesen. Das Theme nutzt <quantity-input> mit einem
       name="quantity"-Feld; fehlt es (z.B. bei Produkten ohne Mengenwahl), gilt 1. */
    const mengeLesen = (element) => {
      const form = element.getAttribute('form') ? document.forms[element.getAttribute('form')] : null;
      const feld =
        (form && form.querySelector('input[name="quantity"]')) ||
        document.querySelector('input[name="quantity"]');
      const wert = feld ? parseInt(feld.value, 10) : 1;
      return Number.isFinite(wert) && wert > 0 ? wert : 1;
    };

    const urspruenglich = Basis.prototype.connectedCallback;

    Basis.prototype.connectedCallback = function () {
      if (typeof urspruenglich === 'function') urspruenglich.call(this);

      /* Zwischenstand der Bundle-Summe merken: Menge und Bundle muessen sich multiplizieren,
         nicht gegenseitig ueberschreiben. */
      this.__bundleSumme = this.basePrice;

      /* CUSTOM 2026-08-06 — Vorbestell-Rabatt beruecksichtigen.
         data-price bleibt bewusst der volle Preis (theme.js schreibt ihn beim Variantenwechsel
         dorthin). Der Abzug passiert erst hier, damit er auch nach einem Wechsel erhalten bleibt. */
      const rabattFaktor = () => {
        const prozent = parseFloat(this.getAttribute('data-pre-order-discount'));
        if (!Number.isFinite(prozent) || prozent <= 0 || prozent >= 100) return 1;
        return (100 - prozent) / 100;
      };

      const neuBerechnen = () => {
        const menge = mengeLesen(this);
        const einzel = this.__bundleSumme || this.basePrice;
        this.updatePrice(Math.round(einzel * menge * rabattFaktor()));
      };

      this.__neuBerechnen = neuBerechnen;

      const form = this.getAttribute('form') ? document.forms[this.getAttribute('form')] : null;
      const ziel = form || document;

      /* 'change' und 'input' beide abdecken: Die Plus/Minus-Buttons des Themes loesen 'change'
         aus, direkte Tastatureingabe 'input'. */
      ['change', 'input'].forEach((typ) => {
        ziel.addEventListener(typ, (event) => {
          if (event.target && event.target.name === 'quantity') neuBerechnen();
        });
      });

      /* Nach einem Variantenwechsel setzt das Theme data-price neu — dann mit der aktuellen
         Menge nachrechnen, sonst zeigt der Button wieder den Einzelpreis. */
      new MutationObserver(() => {
        this.__bundleSumme = this.basePrice;
        neuBerechnen();
      }).observe(this, { attributes: true, attributeFilter: ['data-price'] });

      neuBerechnen();
    };

    /* Bundle-Aenderungen: Summe merken und mit der Menge multiplizieren. */
    const urspruenglichBundle = Basis.prototype.onBundleChanged;

    Basis.prototype.onBundleChanged = function (event) {
      const { items } = event.detail;
      this.__bundleSumme = items.reduce((summe, artikel) => {
        const preis = parseInt(artikel.price, 10) || 0;
        const anzahl = parseInt(artikel.quantity, 10) || 0;
        return summe + preis * anzahl;
      }, this.basePrice);

      if (typeof this.__neuBerechnen === 'function') this.__neuBerechnen();
      else if (typeof urspruenglichBundle === 'function') urspruenglichBundle.call(this, event);
    };

    /* Bereits im DOM stehende Elemente nachtraeglich verdrahten. */
    document.querySelectorAll('product-buy-price').forEach((element) => {
      if (typeof Basis.prototype.connectedCallback === 'function') {
        Basis.prototype.connectedCallback.call(element);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
